import type { TokenResponse } from '@/types/';

export const useAuthStore = defineStore('authStore', () => {
  const config = useRuntimeConfig();

  const userAccessToken = ref();

  const isUserAuthorized = ref(false);

  const userRefreshToken = ref(useCookie('user_refresh_token').value);

  function login() {
    navigateTo(`${config.public.authApiUrl}/login?response_type=code&client_id=${config.public.authClientId}&redirect_uri=${config.public.authCallbackUrl}/auth-response`, {
      external: true,
    });
  }

  function logout() {
    useCookie('user_refresh_token').value = null;
    userAccessToken.value = null;

    navigateTo(`${config.public.authApiUrl}/logout?client_id=${config.public.authClientId}&logout_uri=${config.public.authCallbackUrl}/logout-response`, {
      external: true,
    });
  }

  async function exchangeUserCodeForToken(code: string) {
    const resp = await $fetch(`/api/auth/get-token?code=${code}&redirect_url=${config.public.authCallbackUrl}}`);
    if ((resp as TokenResponse).access_token) {
      userAccessToken.value = (resp as TokenResponse).access_token;
      isUserAuthorized.value = false;
      return resp;
    } else {
      // need to logout or revalidate
      console.log('exchangeUserCodeForToken ERROR', resp);
      const errorMsg = (resp as { error?: string }).error;
      console.log('exchangeUserCodeForToken resp', resp);
      console.error('token error', errorMsg);
      return errorMsg;
    }
  }

  async function renewUserToken(refreshToken?: string) {
    if (userRefreshToken.value) {
      try {
        const resp = await $fetch(`/api/auth/renew-token${refreshToken ? `?refresh_token=${refreshToken}` : ''}`);
        userAccessToken.value = (resp as TokenResponse).access_token;
        isUserAuthorized.value = true;
        return resp;
      } catch (error) {
        userAccessToken.value = null;
        isUserAuthorized.value = false;
        throw createError({
          //statusCode: 500,
          statusMessage: 'There was a problem signing you in. Please try again.',
          data: error || 'unknown',
        });
      }
    } else {
      isUserAuthorized.value = false;
      return { error: 'No refresh token available' };
    }
  }

  async function checkForAuth(refreshToken: string | null) {
    if (!isUserAuthorized.value && !userRefreshToken.value) {
      return false;
    }

    if (userAccessToken.value) {
      return true;
    }

    if (refreshToken) {
      const renewResp = await renewUserToken(refreshToken);
      if ('error' in renewResp) {
        return false;
      }

      return true;
    }

    return false;
  }

  return {
    isUserAuthorized,
    userAccessToken,
    userRefreshToken,
    // accessToken,
    login,
    logout,
    renewUserToken,
    checkForAuth,
    exchangeUserCodeForToken,
  };
});
